import { PureComponent } from 'react'
import PropTypes from 'prop-types'

import { withTranslation } from '../../i18n'
import genresList from '../../constants/genres'
import { Container, GenreButton } from './styles'

class GenresPanel extends PureComponent {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    clear: PropTypes.func.isRequired,
    values: PropTypes.arrayOf(PropTypes.string),
    t: PropTypes.func.isRequired,
    headliner: PropTypes.bool
  }

  state = {
    values: [...this.props.values]
  }

  static defaultProps = {
    values: [],
    headliner: false
  }

  static getDerivedStateFromProps(props, state) {
    const { values: pValues } = props
    const { values: sValues } = state

    if (pValues !== sValues) {
      return {
        values: pValues
      }
    }

    return null
  }

  toggleItem = (selectedValue) => {
    this.setState((prevState) => {
      const { values } = prevState
      const indexOfValue = values.indexOf(selectedValue)
      if (indexOfValue === -1) {
        return { values: [...values, selectedValue] }
      }
      values.splice(indexOfValue, 1)
      return { values: [...values] }
    })
    this.props.onChange(selectedValue)
  }

  clearAll = () => {
    this.setState({ values: [] })
    this.props.clear()
  }

  render() {
    const { t, values, headliner } = this.props
    // const { values } = this.state

    return (
      <Container>
        <GenreButton key="clear" onClick={this.clearAll}>
          <div className="iconContainer">
            <img
              src={values.length !== 0 ? '/static/images/icon-junk-blank.svg' : '/static/images/icon-junk-color.svg'}
              alt=""
            />
          </div>
          <span className="title">{t('clear')}</span>
        </GenreButton>
        {genresList.map((genre) => {
          if (genre.label === 'headliner' && !headliner) return null
          const selected = values.includes(genre.label)
          return (
            <GenreButton key={genre.label} onClick={() => this.toggleItem(genre.label)}>
              <div className="iconContainer">
                <img src={selected ? genre.icon_color : genre.icon_blank} alt="" />
              </div>
              <span className="title">{t(genre.label)}</span>
            </GenreButton>
          )
        })}
      </Container>
    )
  }
}

export default withTranslation(['genres'])(GenresPanel)
